import React from "react";
import { Table } from "react-bootstrap"; // Assuming you're using react-bootstrap for Table

const LeaveSummary = ({ leaveDetails }) => {
  return (
    <div className="container-fluid" id="skill-table-area">
      <div className="row">
        <h6>
          <b>Leave Summary</b>
        </h6>
        <div className="box-body table-responsive container-fluid px-1">
          <Table striped bordered hover>
            <thead id="thcolor" className="text-center">
              <tr>
                <th className="py-1 px-2">Type</th>
                <th className="py-1 px-2">Accrued</th>
                <th className="py-1 px-2">Applied</th>
                <th className="py-1 px-2">Approved</th>
                <th className="py-1 px-2">Balance</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {leaveDetails.length > 0 ? (
                leaveDetails.map((leave, index) => (
                  <tr key={index}>
                    <td className="py-1 px-2">{leave.LeaveType}</td>
                    <td className="py-1 px-2">{leave.LeaveAccrued}</td>
                    <td className="py-1 px-2">{leave.LeaveApplied}</td>
                    <td className="py-1 px-2">{leave.LeaveApproved}</td>
                    <td className="py-1 px-2">{leave.LeaveBalance}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="py-1 px-2">
                    No Record
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default LeaveSummary;
